import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RegistryCollectionItemTileActions from './RegistryCollectionItemTileActions';
import ProductPrice from '../product/ProductPrice';

class RegistryCollectionItemRow extends Component {
  constructor(props) {
    super(props);

    this.updateQuantity = this.updateQuantity.bind(this);
    this.showProductModal = this.showProductModal.bind(this);
    this.addToCart = this.addToCart.bind(this);

    this.state = {
      quantity: 1
    };
  }

  updateQuantity(event) {
    this.setState({
      quantity: event.target.value
    });
  }

  showProductModal() {
    const { collectionItem, isDefaultGiftCard, onShowProduct } = this.props;
    onShowProduct(collectionItem, isDefaultGiftCard);
  }

  addToCart() {
    const { collectionItem, onAddToCart } = this.props;
    const { quantity } = this.state;

    onAddToCart(collectionItem, quantity).catch((e) => {
      if (e.response.errorData) {
        if (e.response.errorData.isGroupGift) {
          this.setState({
            contribution: e.response.errorData.maxContribution
          });
        }
        if (e.response.errorData.maxContribution > 0) {
          this.setState({ quantity: e.response.errorData.maxContribution });
        } else if (e.response.errorData.availableQuantity > 0) {
          this.setState({ quantity: e.response.errorData.availableQuantity });
        }
      }
    });
  }

  render() {
    const { collectionItem, isDefaultGiftCard } = this.props;
    const { quantity } = this.state;

    if (collectionItem === null) return null;

    // for products with mutliple looks
    const imageMedium = collectionItem.product_look_views && collectionItem.product_look_views[0].image_links.A_480;
    const productImage = imageMedium || (collectionItem.images.length > 0 && collectionItem.images[0].medium);

    const isGroupGift = !isDefaultGiftCard && collectionItem.contributions.group_gift;
    const stillNeeds = !isDefaultGiftCard && collectionItem.contributions.still_needs;
    const isFulfilled = !isDefaultGiftCard && collectionItem.contributions.show_as_fulfilled;
    const isReserved = !isDefaultGiftCard && collectionItem.contributions.show_as_reserved;
    const isMostWanted = !isDefaultGiftCard && collectionItem.most_wanted;
    const canPurchase = collectionItem.actions && collectionItem.actions.purchase;
    const showContributions = !(!canPurchase || collectionItem.contributions.hide_contributions || isFulfilled || isReserved);
    const canQuickAdd = canPurchase && (
      (collectionItem.type === 'EXTERNAL' && collectionItem.cash_fund && !isGroupGift)
      || (collectionItem.type !== 'EXTERNAL' && !isGroupGift)
    );
    const showActions = !isFulfilled && !isReserved;

    // Replace these / move them up
    // const ridpUrl = '';

    const isFreeShip = collectionItem.free_shipping;
    /*
    collectionItem.shippable &&
    !collectionItem.delivery_surcharge &&
    !(isGroupGift && collectionItem.contributions.completed_units > 0);
    */

    return (
      <div className="row">
        <a role="button" onClick={this.showProductModal} className="block-link pdp-link">
          <div className="col-sm-5 shop-entity-details">
            <div className="photo-wrapper pull-left clearfix">
              <div className={`entity-image thumbnail thumbnail-square${collectionItem.type === 'EXTERNAL' ? ' external' : ''}`}>
                {isMostWanted && !isFulfilled && <div className="shop-badge shop-badge-most-wanted-small" />}

                <img
                  src={productImage}
                  className={!canPurchase && !isFulfilled ? 'discontinued' : ''}
                  alt={collectionItem.name}
                />
              </div>
            </div>
            <div className="product-details">
              <h6 className="brand-name">{collectionItem.brand && collectionItem.brand.name}</h6>
              <h5 className="entity-name">{collectionItem.name}</h5>
            </div>
          </div>
        </a>
        <div className="col-sm-1">
          {isDefaultGiftCard && <h5 className="price"> Starting at $25 </h5>}
          {!isDefaultGiftCard && !isGroupGift && <h5 className="price"><ProductPrice sku={collectionItem} hidePriceLabels /></h5>}
          {isGroupGift && !isFulfilled && <h5 className="price"><em>Contribute what you wish</em></h5>}
          {!isDefaultGiftCard && isFreeShip && !isFulfilled && !isGroupGift && canPurchase && <strong className="free-ship">FREE SHIPPING</strong>}
        </div>
        <div className="col-sm-1 text-center">
          {showContributions && !isGroupGift && <h5>{collectionItem.requested_quantity}</h5>}
        </div>
        <div className="col-sm-1 text-center">
          {showContributions && <h5>{stillNeeds}</h5>}
        </div>
        <div className="col-sm-4">
          {isFulfilled
            && (
            <div className="input-group registry-item-actions">
              <div className="qty pull-left visible-lg-block" />
              <h5 className="registry-item-status fulfilled text-center">
                <span className="zolaicon zolaicon-checkmark" />Purchased
              </h5>
            </div>
            )
          }
          {isReserved
          && (
          <div className="input-group registry-item-actions">
            <div className="qty pull-left visible-lg-block" />
            <h5 className="registry-item-status fulfilled text-center">
              <span className="zolaicon zolaicon-checkmark" />On Hold
            </h5>
          </div>
          )
          }
          {showActions
            && (
            <div className="input-group registry-item-actions">
              {canQuickAdd
                ? (
                  <input
                    type="number"
                    className="form-control text-center qty"
                    name="quantity"
                    value={quantity}
                    onChange={this.updateQuantity}
                  />
                )
                : <div className="qty pull-left visible-lg-block" />
              }
              <RegistryCollectionItemTileActions
                collectionItem={collectionItem}
                onAddToCart={this.addToCart}
                onShowProduct={this.showProductModal}
                isDefaultGiftCard={isDefaultGiftCard}
              />
            </div>
            )
          }
        </div>
      </div>
    );
  }
}

RegistryCollectionItemRow.propTypes = {
  collectionItem: PropTypes.shape({}),
  onAddToCart: PropTypes.func.isRequired,
  onShowProduct: PropTypes.func.isRequired,
  isDefaultGiftCard: PropTypes.bool,
};

export default RegistryCollectionItemRow;



// WEBPACK FOOTER //
// ./src/components/registry/RegistryCollectionItemRow.jsx